import React from 'react'

import Layout from '../../App/layout'
import ContentLayout from '../../../components/utility/layoutContent'
import LayoutContentWrapper from '../../../components/utility/layoutWrapper'
import LeadGenerationContainer from '../../LeadGeneration/LeadGenerationContainer'

class CustomerNewOrderPage extends React.Component {
    componentDidMount() {
        document.title = 'Lead Generation | OSH CRM'
    }

    render () {
      const { match } = this.props
      const { id } = match.params

        return (
            <Layout>
                <LayoutContentWrapper breadcrumbs={
                    [
                        { path: '/customers', name: 'Customers' },
                        { path: `/customers/${id}`, name: `${id}` },
                        { path: `/customers/${id}/orders/new`, name: 'Lead Generation' }
                    ]
                }>
                    <ContentLayout>
                      <LeadGenerationContainer customerId={id} />
                    </ContentLayout>
                </LayoutContentWrapper>
            </Layout>
        )
    }
}

export default CustomerNewOrderPage
